/**************************************************
 * Nombre:       Formulario_Fecha
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {CalendarMonthOutlined, CalendarTodayOutlined} from "@mui/icons-material";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Formulario_Fecha = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                    <IngresoFecha Icono={CalendarTodayOutlined} nombre={'Fecha'}
                                  dato={'fecha'} {...props} ventana={false}
                                  requerido={'La fecha son requeridas'}
                    />



            </Grid>

        </form>

    )

}
export default Formulario_Fecha